export const isLocal = () => ['dashboard-local.wingalpha.com:3030'].includes(window.location.host);
export const isStage = () => ['dashboard-stage.wingalpha.com'].includes(window.location.host);
export const isDev = () => ['dashboard-dev.wingalpha.com'].includes(window.location.host);
export const isProd = () => ['dashboard.wingalpha.com'].includes(window.location.host);

export const ENV = {
  local: isLocal(),
  stage: isStage(),
  dev: isDev(),
  prod: isProd(),
}
